import { render, staticRenderFns } from "./CMContactGroupList.vue?vue&type=template&id=13c9e7b2&"
import script from "./CMContactGroupList.vue?vue&type=script&lang=js&"
export * from "./CMContactGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c9e7b2')) {
      api.createRecord('13c9e7b2', component.options)
    } else {
      api.reload('13c9e7b2', component.options)
    }
    module.hot.accept("./CMContactGroupList.vue?vue&type=template&id=13c9e7b2&", function () {
      api.rerender('13c9e7b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/CMContactsPage/CMContactGroupList.vue"
export default component.exports